import { DrEntity } from './dr-entity';
import { ExportStreamOptions } from './export-stream-options';
import { OrderedCodeSet } from './ordered-code-set';
import { TaggedEntity } from './tagged-entity';
import { ViewType } from './view';
import { ExportState } from './export-stream';

export enum ExportVolumeState {
    Open = 'Open',
    Prepared = 'Prepared',
    Produced = 'Produced',
    UNKNOWN_CODE = 'UNKNOWN_CODE'
}

export enum ExportVolumeDedupeState {
    Included = 'Included',
    Excluded = 'Excluded',
    UNKNOWN_CODE = 'UNKNOWN_CODE'
}

export class ExportRequest extends DrEntity {
    exportStreamHandle: string;
    detailedEstimateRequested: boolean;
    dateRequested: number;
    quickEstimate: number;
    detailedEstimate: number;
    detailedEstimateSize: number;

    constructor(value?: Partial<ExportRequest>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }
}

export class ExportVolume extends DrEntity {
    name: string;
    description: string;
    documentCount: number;
    childViewCount: number;
    viewType: ViewType;
    taggedEntityList: Array<TaggedEntity>;
    createdBy: string;
    createdOn: number;
    sourceViewHandle: string;
    deDupeDocumentCount: number;
    priority: number;
    archived: boolean;
    orderedCodeSets: Array<OrderedCodeSet>;
    exportVolumeState: ExportVolumeState;
    exportVolumeDedupeState: ExportVolumeDedupeState;
    exportVolumeDedupeStateChangePending: boolean;
    documentSize: number;
    exportRequest: ExportRequest;
    options: ExportStreamOptions;
    exportVolumeDisplayState: ExportState;
    exportDuplicatesVolume: boolean;
    removable: boolean;

    stateDisplay: string;

    constructor(value?: Partial<ExportVolume>) {
        super(value);
        if (value) {
            if (value.taggedEntityList) {
                value.taggedEntityList = value.taggedEntityList.map(tag => new TaggedEntity(tag));
            }
            if (value.options) {
                value.options = new ExportStreamOptions(value.options);
            }
            if (value.exportRequest) {
                value.exportRequest = new ExportRequest(value.exportRequest);
            }
            Object.assign(this, value);

            this.setExportVolumeState();
        }
    }

    setExportVolumeState(): void {
        this.stateDisplay = '';
        if (this.exportVolumeDisplayState) {
            this.stateDisplay = this.exportVolumeDisplayState.charAt(0) + this.exportVolumeDisplayState.slice(1).toLowerCase();
        }
    }
}
